export const PRIMARY_FONT = `"Pinyon Script", cursive;`;
export const SECONDARY_FONT = `"Libre Baskerville", serif;`;
export const FANTASY = PRIMARY_FONT;
export const CURSIVE = PRIMARY_FONT;
